import { takeLatest, takeLeading } from 'redux-saga/effects';
import { formManagementSlice } from './formManagement.slice';
import {
  saveDraftReadingTaskWorker,
  changeScoringFormDataWorker,
  viewerToolActionWorker,
  handleScoringFormRenderWorker,
  submitReadingTaskWorker,
  clearLSWorker,
} from './workers';

const {
  saveDraftReadingTask,
  changeScoringFormData,
  viewerToolAction,
  scoringFormRenderHook,
  submitReadingTask,
  clearLS,
} = formManagementSlice.actions;

export function* formManagementSaga() {
  yield takeLatest(saveDraftReadingTask.type, saveDraftReadingTaskWorker);
  yield takeLatest(changeScoringFormData.type, changeScoringFormDataWorker);
  yield takeLatest(viewerToolAction.type, viewerToolActionWorker);
  yield takeLatest(scoringFormRenderHook.type, handleScoringFormRenderWorker);
  // A submit owns the whole complete -> next-visit transition. Ignore repeated
  // clicks until that flow finishes; takeLatest would cancel the coordinator
  // while its already-started HTTP request can still reach the backend.
  yield takeLeading(submitReadingTask.type, submitReadingTaskWorker);
  yield takeLatest(clearLS.type, clearLSWorker);
}
